import comp from "./AIFeedbackModal";
export default comp;
